import { render, staticRenderFns } from "./certificates.vue?vue&type=template&id=7f0aa0c7&scoped=true&lang=pug&"
import script from "./certificates.vue?vue&type=script&lang=js&"
export * from "./certificates.vue?vue&type=script&lang=js&"
import style0 from "./certificates.vue?vue&type=style&index=0&id=7f0aa0c7&scoped=true&lang=css&"
import style1 from "./certificates.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0aa0c7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f0aa0c7')) {
      api.createRecord('7f0aa0c7', component.options)
    } else {
      api.reload('7f0aa0c7', component.options)
    }
    module.hot.accept("./certificates.vue?vue&type=template&id=7f0aa0c7&scoped=true&lang=pug&", function () {
      api.rerender('7f0aa0c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/card/certificates/certificates.vue"
export default component.exports